/** Temporary, explicit cohort. Always use a verified JWT owner or consumed OAuth state. */
export const CONNECTION_VALIDATION_USER_ID = "f980723a-3c27-4ddb-8ee4-a0aa4468454b";

// Explicit allowlist: adding a future catalog provider must not silently expand this cohort.
const EXPANSION_READ_VALIDATION_PROVIDERS = new Set([
  "dropbox", "todoist", "trello", "slack", "microsoft_teams",
]);

/** Read-only account validation. Public rollout, write consent and writes keep their own gates. */
export function isExpansionReadValidationAccount(provider: string, owner?: string | null): boolean {
  return owner === CONNECTION_VALIDATION_USER_ID && EXPANSION_READ_VALIDATION_PROVIDERS.has(provider);
}
